import React, {useState} from "react"
import './LoadingSpinner.css'
import { usePromiseTracker } from "react-promise-tracker"
import ClipLoader from "react-spinners/ClipLoader"
// import BounceLoader from "react-spinners/BounceLoader"

function LoadingSpinner(props) {

    const { promiseInProgress } = usePromiseTracker({area: props.area})
    const color = '#0d6efd';
    const [start, setStart] = useState(false)

    if (promiseInProgress === true) {
        if (!start) {
            setStart(true)
        }
        // if (!!props.area && props.area === 'login') {

        //     return (
        //         <div className='spinner'>
        //             <ClipLoader
        //                 color='#f00'
        //                 loading={promiseInProgress}
        //                 // cssOverride={override}
        //                 size='300px'
        //                 // aria-label="Loading Spinner"
        //                 // data-testid="loader"
        //             />
        //         </div>
                
        //     )

        // } 
        
        return (
            <div className='spinner'>
                <ClipLoader
                    
                    color={color}
                    loading={promiseInProgress}
                    // cssOverride={override}
                    size={!!props.size ? props.size: '150px'}
                    // aria-label="Loading Spinner"
                    // data-testid="loader"
                />
            </div>
            
        )
    } else {
        // console.log("I am not spinning - props, start", props, start)
        if (start) {
            // console.log("no promise in progress")
            // on end call props.onEndOfPromise
            
            setStart(false)
            if (!!props.onEndOfPromise) {
                // props.onEndOfPromise()
                setTimeout((param) => {props.onEndOfPromise(param)}, 200 )
            }

            // setTimeout(() => {setStart(false); props.onEndOfPromise()}, 2000 )
            
        }
        
        return null
    }
    
}

export default LoadingSpinner
